import type { TabProps } from './Tabs.types';

/**
 * Get index of active tab in passed tabs array
 *
 * @param {tabs} TabProps[] - Array of tab data
 * @param {activeTabId} string - active tab id
 * @returns `number | null` - active tab index (or null if not found)
 *
 * @see {@link TabProps | ./Tabs.types.ts#TabPropa} TabsProps in Tabs.types
 */
export function getActiveTabIndex(tabs: TabProps[] = [], activeTabId: string | null = null) {
  if (activeTabId === null) {
    return null;
  }
  const activeTabIndex = tabs.findIndex(({ id }) => id === activeTabId);
  if (activeTabIndex === -1) {
    return null;
  }
  return activeTabIndex;
}
